// extracted by mini-css-extract-plugin
module.exports = {"column":"OptionalAttributeField__column","inputField":"OptionalAttributeField__inputField","mappingFieldRow":"OptionalAttributeField__mappingFieldRow"};